import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-base text-background-50"></i>
              </span>
              <span className="text-lg font-heading font-bold text-foreground-900">
                7777影院
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              7777影院汇集最新电影、免费电视剧和热门综艺节目，支持在线不缓冲播放，资源每日更新，让你第一时间追剧看电影。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              影视分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              快捷链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  网站首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/dianshiju"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  最新电视剧
                </Link>
              </li>
              <li>
                <Link
                  to="/category/zongyi"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  热门综艺
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              联系方式
            </h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-primary-500"></i>
                <span>contact@7777yingyuan.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-customer-service-line text-primary-500"></i>
                <span>在线客服 7×24小时</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-wechat-line text-primary-500"></i>
                <span>微信公众号：7777影院</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between mt-10 pt-6 border-t border-background-200">
          <p className="text-xs text-foreground-500">
            &copy; 2026 7777影院 版权所有 | 本站所有资源均来自互联网，仅供学习交流使用
          </p>
          <div className="flex items-center gap-4 mt-3 sm:mt-0">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}